import type { AuthBindings } from "@refinedev/core";
import { useAuthStore } from "../../stores/authStore";

export const authProvider: AuthBindings = {
  login: async () => ({ success: true }),
  logout: async () => {
    useAuthStore.getState().clearSession();
    return { success: true, redirectTo: "/login" };
  },
  check: async () => ({ authenticated: !!useAuthStore.getState().accessToken, redirectTo: "/login" }),
  getIdentity: async () => useAuthStore.getState().user,
  getPermissions: async () => useAuthStore.getState().user?.permissions ?? [],
  onError: async () => ({ error: undefined })
};
